import axios from 'axios';
import envs from '../../../../shared/envs/public';

const api = axios.create({
  baseURL: envs.webApiUrl(),
  withCredentials: true,
});

export default api;
